import { render } from "./ProfileModal.vue?vue&type=template&id=72de78ef&scoped=true"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"

import "./ProfileModal.vue?vue&type=style&index=0&id=72de78ef&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72de78ef"]])

export default __exports__